import Client from "./Clients/AxiosClient";
const resource = "api/v1/admin/pengerjaan/tryout/hasil/download";
const resourceAdmin = "api/v1/admin/pengerjaan/tryout/report/download";

export default {
  download(id) {
    return Client.get(`${resource}/${id}`, {
      responseType: "blob",
    });
  },

  downloadReport(id, minDuration) {
    const params = {};
    if (minDuration && Number(minDuration) > 0) {
      params.min_duration = Number(minDuration);
    }

    return Client.get(`${resourceAdmin}/${id}`, {
      responseType: "blob",
      params,
    });
  },
};
